import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppInitService } from '../../../digigov/services/app-init.service';
import { AuthenticationService } from '../../services/authentication.service';
import { TermsDialogComponent } from './terms-dialog/terms-dialog.component';

@Component({
  selector: 'dg-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  isCopyRight: string;
  isfooterLogo: string;
  terms;
  constructor(
    private appInitService: AppInitService,
    private dialog: MatDialog
  ) {
    console.log();
  }

  ngOnInit(): void {
    this.isCopyRight = this.appInitService.appConfig.branding.copyright;
    this.isfooterLogo = this.appInitService.appConfig.branding.footerLogo;
    console.log();
  }

  openTermsDialog() {
    this.dialog.open(TermsDialogComponent, {
      data: {
        showButton: false,
        // termData: this.terms,
      },
    });
  }
}
